import { styled } from "@mui/material/styles";
import MuiBox from "@mui/material/Box";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import Divider from "@mui/material/Divider";
import { THEME_COLORS } from "constants/theme";

const Box = styled(MuiBox)(({ theme }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  width: "100%",
  height: "100%",
  background: THEME_COLORS[theme.palette.mode.toUpperCase()].SECONDARY_BG,
  borderRadius: "9px",
  overflow: "hidden",
}));

const CustomDrawerPanel = ({ title, icon, styles = {}, className = "", tabs, children, actions }) => {
  return (
    <Box className={className}>
      {title && (
        <>
          <SoftBox sx={{ flexShrink: 0, padding: "20px 16px 0 16px", display: "flex", alignItems: "center", ...(styles.titleWrapper) }}>
            {icon}
            <SoftTypography variant="h6" color="text" fontWeight="bold" sx={{ ml: 2 }}>
              {title}
            </SoftTypography>
          </SoftBox>
          {actions && <SoftBox sx={{ flexShrink: 0, padding: "0 16px" }}>{actions}</SoftBox>}
          <Divider sx={{ flexShrink: 0 }} />
        </>
      )}
      {tabs && <SoftBox sx={{ flexShrink: 0, padding: "0 16px" }}>{tabs}</SoftBox>}
      <SoftBox
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
          padding: "0 16px 20px 16px"
        }}
      >
        {children}
      </SoftBox>
    </Box>
  );
};

export default CustomDrawerPanel;
